// @see https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#bookmark=id.qah3o2svel5d

const RunnerSafeType = {
    StolenBase: { key: 'stolenBase', name: 'Stolen Base' },
    AttemptedPickoff: { key: 'attemptedPickoff', name: 'Attempted Pickoff' },
    FieldingError: { key: 'fieldingError', name: 'Fielding Error' },
    ThrowingError: { key: 'throwingError', name: 'Throwing Error' },
    OnLastPlay: { key: 'onLastPlay', name: 'On Last Play' },
    OnThrow: { key: 'onThrow', name: 'On Throw' },
    ForcePlay: { key: 'forcePlay', name: 'Force Play' },
    DefensiveIndifference: { key: 'defensiveIndifference', name: 'Defensive Indifference' }, // @see https://www.baseball-reference.com/bullpen/Defensive_Indifference
    OnPassedBall: { key: 'onPassedBall', name: 'On Passed Ball' },
    OnWildPitch: { key: 'onWildPitch', name: 'On Wild Pitch' },
    TaggedUp: { key: 'taggedUp', name: 'Tagged Up' },
    ExtraRunner: { key: 'extraRunner', name: 'Extra Runner' },
    Safe: { key: 'safe', name: 'Safe' },
};

export default RunnerSafeType;